import { SkeletonCard } from '../../../components/Skeleton/Skeleton';
import { GRID_COLUMNS } from '../config/dashboardConfig';
import './DashboardLoadingSkeleton.css';

/**
 * 대시보드 로딩 스켈레톤 컴포넌트
 * API에서 카드 위치 정보를 가져오는 동안 표시됩니다.
 */
const DashboardLoadingSkeleton = () => {
  // 각 그룹별 카드 개수 (기본 레이아웃과 유사하게)
  const commonCardsCount = 3;
  const drRelatedCardsCount = 6;

  return (
    <div className="dashboard-page-container">
      {/* 헤더 스켈레톤 */}
      <div className="dashboard-header">
        <div className="flex justify-between align-center mb-20">
          <div className="skeleton-text-title" style={{ width: '200px', height: '32px' }} />
          <div className="skeleton-button" style={{ width: '120px', height: '40px' }} />
        </div>
      </div>

      {/* 공통 그룹 스켈레톤 */}
      <div className="dashboard-skeleton-group">
        <div className="dashboard-skeleton-grid">
          {Array.from({ length: commonCardsCount }).map((_, index) => (
            <div key={`common-${index}`} className="dashboard-skeleton-card-wrapper">
              <SkeletonCard 
                width="100%" 
                height="200px"
                className="dashboard-skeleton-card"
              />
            </div>
          ))}
        </div>
      </div>

      {/* 지역 선택 및 집계 기준 스켈레톤 */}
      <div className="flex my-10 gap-10">
        <div className="skeleton-region-selector" style={{ width: '300px', height: '40px' }} />
        <div className="skeleton-aggregation" style={{ width: '300px', height: '40px' }} />
      </div>

      {/* DR 관련 그룹 스켈레톤 */}
      <div className="dashboard-skeleton-group">
        <div className="dashboard-skeleton-grid">
          {Array.from({ length: drRelatedCardsCount }).map((_, index) => (
            <div key={`dr-${index}`} className="dashboard-skeleton-card-wrapper">
              <SkeletonCard 
                width="100%" 
                height="200px"
                className="dashboard-skeleton-card"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DashboardLoadingSkeleton;

